module.exports = __webpack_public_path__ + "img/tools-doc.b7b18eaa.png";